import { render } from "./DropdownSearch.vue?vue&type=template&id=45cd2a96"
import script from "./DropdownSearch.vue?vue&type=script&lang=js"
export * from "./DropdownSearch.vue?vue&type=script&lang=js"

import "./DropdownSearch.vue?vue&type=style&index=0&id=45cd2a96&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__